import { render, staticRenderFns } from "./UserDetailsEdit.vue?vue&type=template&id=fd437f4e&"
import script from "./UserDetailsEdit.vue?vue&type=script&lang=js&"
export * from "./UserDetailsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports